import { LoadingOutlined } from '@ant-design/icons'
import cn from 'classnames'

const Button = ({
  children,
  variant = 'contained',
  color = 'primary',
  className,
  loading = false,
  disabled = false,
  ...props
}) => {
  const isDisabled = disabled || loading

  return (
    <button
      className={cn(
        'font-sfui text-lg px-3 py-3.5 font-bold rounded-md',
        'md:px-12 md:h-[52px]',
        isDisabled
          ? 'bg-gray-200 text-black/25 cursor-not-allowed'
          : variant === 'contained'
            ? color === 'primary'
              ? 'bg-g500 text-white'
              : 'bg-white text-g400'
            : color === 'primary'
              ? 'bg-transparent border border-solid border-g400 text-g400'
              : 'bg-transparent border border-solid border-white text-white',
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {loading && <LoadingOutlined className="mr-2" />}
      {children}
    </button>
  )
}

export default Button
